<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4" v-if="resetSuccess===false">
            <CCardBody>
              <CForm>
                <h1>Forgot Password</h1>
                <p class="text-muted">Enter new password twice to complete password reset process</p>
 
                <CInput
                  placeholder="Email Address"
                  autocomplete="username email"
                  v-model="email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="New Password"
                  type="password"
                  autocomplete="new-password"
                  v-model="password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CInput
                  placeholder="New Password (Again)"
                  type="password"
                  autocomplete="new-password"
                  v-model="password2"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="primary" @click="handleSubmit" class="px-4">Reset Password</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard class="p-4" v-if="resetSuccess===true">
            <CCardBody>
              <CRow>
                
                <p class="text-muted">Your password has been successfully reset -  please return to the <a href="/pages/login">Login Page</a> to access the portal</p>
 
              </CRow>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
    export default {
      name: 'ResetPassword',
        data(){
            return {
                loginError : false,
                resetSuccess: false,
                email : "",
                password : "",
                password2: ""
            }
        },
        methods : {
            handleSubmit(e){
                e.preventDefault()
                var self = this;
                if (this.password.length == 0) {
                    self.loginError = "Password cannot be blank";
                } else if (this.password != this.password2) {
                    self.loginError = "Passwords to not match - please try again"    
                } else {
                    // Reset the password

                }
                if (this.password.length > 0) {
                    this.$http.post(this.$apiUrl + '/reset', {
                        emailAddress: this.email,
                        newPassword: this.password, 
                        resetToken: this.$route.query.token
                    })
                    .then(response => {
                        if (response.data.success) {
                            self.resetSuccess = true;
                          //  this.$snotify.success("Reset request in progress - please check your email to continue", "Success!");
                        } else {
                          this.$snotify.error("There was an error processing your request - please try again");
                           // self.loginError = true;
                        }
                        console.log(response);
                    })
                    .catch(function (error) {
                        this.$snotify.error("There was an error processing your request - please try again");
                        console.error(error.response);
                    });
                }
            }
        }
    }
</script>